// require("./Proto");
import HTTPSender from "@/js/HTTPSender";
import ServResponse from "@/js/ServResponse";
import DataManagerData from "./DataManagerData";
import { DataFilterType, DataPropType } from "./DataFilter";
const dateFormat1 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
const dateFormat2 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{1,9}Z*$/;
const dateFormat3 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{1,9}$/;

function reviver(key, value) {
  //TODO FIX
  if (typeof value === "string" && (dateFormat3.test(value) || dateFormat1.test(value))) {
    return new Date(value + "Z");
  } else if (typeof value === "string" && (dateFormat1.test(value) || dateFormat2.test(value))) {
    return new Date(value);
  }
  return value;
}
// export class Product {
//   constructor(object) {
//     this = Object.assign({}, object);
//   }
//   toString = () => { return this.Name + ", " + this.Country.Name; }
// }

class DataManager {
  constructor() {}

  static user = null;

  static UserTypes = Object.freeze({
    User: 1,
    Owner: 2,
    OnwerWithPermissions: 4,
    SuperUser: 8,
    All: 0xff,
  });

  static userHasAccess(user) {
    return (user & DataManager.user.userType) > 0;
  }

  static WeekDaysShort = Object.freeze(["Нед", "Пон", "Вт", "Ср", "Чет", "Пет", "Съб"]);
  static WeekDays = Object.freeze(["Неделя", "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"]);

  static data = Object.assign({}, DataManagerData);

  static __reload() {
    HTTPSender.AbortAll();
    DataManager.user = null;
    DataManager.data = Object.assign({}, DataManagerData);
  }

  static getTableItems(tableName) {
    //TODO fix da ne vzema tablicata po property-to na kolonata
    if (!tableName) return [];
    var propObj = tableName;
    if (tableName.indexOf(".") > -1) {
      propObj = propObj.substring(tableName.indexOf(".") + 1, tableName.length);
    }
    try {
      var oo = DataManager.getData(DataManager.data[propObj], true);
      return oo;
    } catch {
      return [];
    }
  }

  static getFilterDistinctValues(data, header) {
    if (header.proptype == DataPropType.Object) {
      return DataManager.getTableItems(header.key);
    } else if (header.filtertype == DataFilterType.WeekDays) {
      return DataManager.WeekDays.slice(0, DataManager.WeekDays.length);
    } else if (data.data) {
      return (
        data.data
          .filter((o) => Object.byString(o, header.key))
          .map((p) => Object.byString(p, header.key))
          // .map((p) => Object.byString(p, header.key).Name ? Object.byString(p, header.key).Name : Object.byString(p, header.key).toString())
          .unique()
      );
    } else {
      return [];
    }
  }

  /**
   *
   * @param {Data} id DataType
   * @param {Boolean} notFiltered true for not filtered data
   */
  static getData(data, notFiltered) {
    var payload = data.data;
    if (notFiltered || !(payload instanceof Array)) {
      return payload instanceof Array ? payload.sortBy(data.sort) : payload;
    }
    return (
      payload
        .filter((i) => DataManager._filterFn(data.headers, i))
        // .filter((d) => DataManager._filterFnuser(datatype, d))
        .sortBy(data.sort)
    ); //TODO;
  }

  /**
   *
   * @param {DataHeader} headers
   * @param {*} i
   * @returns
   */
  static _filterFn(headers, i) {
    return headers.every((h) => {
      if (h.filtervalues.length == 0 || h.filtervalues[0] == null || h.filtervalues[0] === "") return true; //return !(f.type || f.propname); //return false;
      var propVal = Object.byString(i, h.value);
      if (propVal == null) return false;
      switch (h.filtertype.id) {
        case DataFilterType.Equals.id:
          if (h.proptype == DataPropType.Date || h.proptype == DataPropType.DateShort) {
            return propVal.getDateWithoutTime().getTime() == h.filtervalues[0].getDateWithoutTime().getTime();
          } else {
            return propVal == h.filtervalues[0]; //return h.filter.indexOf(i[f.propname]) !== -1;
          }
        case DataFilterType.Contains.id:
          return propVal.toString().toLowerCase().indexOf(h.filtervalues[0].toLowerCase()) != -1; //return h.filter.some(function(v){ return i[f.prop].toString().indexOf(v) !== -1})
        case DataFilterType.Between.id:
          if (h.proptype == DataPropType.Date || h.proptype == DataPropType.DateShort) {
            return (
              h.filtervalues[0].getDateWithoutTime().getTime() <= propVal.getTime() && h.filtervalues[h.filtervalues.length - 1].getTime() >= propVal.getTime()
            );
          } else return propVal >= h.filtervalues[0] && propVal <= h.filtervalues[1];
        case DataFilterType.LessThan.id:
          return propVal <= h.filtervalues[0];
        case DataFilterType.MoreThan.id:
          return propVal >= h.filtervalues[0];
        case DataFilterType.In.id:
          if (h.proptype == DataPropType.Object) {
            return h.filtervalues.indexOf(propVal) != -1;
          } else if (h.proptype == DataPropType.String || h.proptype == DataPropType.HTMLString || h.proptype == DataPropType.Number) {
            return h.filtervalues.indexOf(propVal) != -1;
          } else {
            return h.filtervalues.indexOf(propVal.toString()) !== -1;
          }
        case DataFilterType.WeekDays.id: {
          return Object.values(propVal).some((pv) => h.filtervalues.indexOf(pv.toString()) !== -1);
        }
        default:
          return false;
      }
    });
  }

  static formatGridData(header, value) {
    var type = header.proptype;
    if (value === undefined) {
      return "";
    }
    if (value === null) {
      if (header.isNullable) {
        return "";
      } else {
        // throw v browsera console.log(header);
      }
    }
    if (type == DataPropType.Date && !!value) {
      return value.toTremolFpString();
    } else if (type == DataPropType.DateShort && value) {
      return value.toTremolFpStringShort();
    } else if (type == DataPropType.Money) {
      return value.toFixed(2);
    } else if (type == DataPropType.Money4digits) {
      return value.toFixed(4);
    } else if (type == DataPropType.QTY) {
      return value.toFixed(3);
    } else if (type == DataPropType.BOOL) {
      if (value == true) return "Да";
      else if (value == false) return "Не";
      else return "";
    } else if (type == DataPropType.String && value) {
      return value.toString();
    } else if (type == DataPropType.Object && value) {
      return value.toString();
    } else if (type == DataPropType.Identificator) {
      return "#" + value.toString();
    } else if (type == DataPropType.HTMLString && value) {
      return value.toString();
    }
    // else if (type == DataPropType.Month) { //вече е стринг с къстъм сорт
    //     return DataManager.MonthNames[value - 1];
    // }
    else {
      return value;
    }
  }

  static login(username, password, callback) {
    HTTPSender.SendPOSTreq(JSON.stringify({ email: username, password: password }), "EVUser/login")
      .done(async (resp) => {
        if (!resp.success) {
          // console.log("resp not success");
          if (callback) callback(new ServResponse(resp.err.code, resp.err.message, null));
          return;
        }
        HTTPSender.SetBearer(resp.payload.token);
        DataManager.user = resp.payload;

        if (DataManager.user.id == 1 || DataManager.user.id == 2 || DataManager.user.id == 6) {
          DataManager.user.userType = this.UserTypes.SuperUser;
        } else if (DataManager.user.id == 14) {
          DataManager.user.userType = this.UserTypes.OnwerWithPermissions;
        } else {
          DataManager.user.userType = this.UserTypes.Owner;
        }

        try {
          DataManager.user.settings1 = JSON.parse(DataManager.user.settings1);
        } catch {
          /** */
        }
        if (!DataManager.user.settings1) {
          DataManager.user.settings1 = {};
        }
        // if (!DataManager.user.settings1.lld || DataManager.user.settings1.lld.getDateWithoutTime() != new Date().getDateWithoutTime()) {
        //   DataManager.user.settings1.lld = new Date();
        //   DataManager.user.settings1.lct = 0;
        // }
        // DataManager.user.settings1.lct++;
        // HTTPSender.SendPOSTreq(JSON.stringify(DataManager.user.settings1), "EVUser/UpdateCpuser/")
        //   .done(() => {})
        //   .fail(() => {});

        var keyz = Object.keys(DataManager.data);
        keyz.asyncForEach(async (key) => {
          var data = DataManager.data[key];
          if (data.loadOnStart) {
            await DataManager.loadData(data);
          }
        });
        if (callback) callback(new ServResponse(200, null, resp));
      })
      .fail((xhr, textStatus, errorThrown) => {
        if (callback) callback(new ServResponse(xhr.status, " " + errorThrown, null));
      });
  }

  // /**
  //  *
  //  * @param {string} new_password
  //  * @param {string} new_password_confirm
  //  * @param {function(ServResponse)} callback
  //  */
  // static changePassword(new_password, new_password_confirm, callback) {
  //   HTTPSender.SendPOSTreq(JSON.stringify({ new_password: new_password, new_password_confirm: new_password_confirm }), "changePassword")
  //     .done((resp) => {
  //       if (callback) callback(resp);
  //     })
  //     .fail((xhr, textStatus, errorThrown) => {
  //       if (callback) callback(new ServResponse(xhr.status, errorThrown, null));
  //     });
  // }
  // static logout(callback) {
  //   HTTPSender.SendGETreq("logout")
  //     .done(() => {
  //       DataManager.__reload();
  //       if (callback) callback();
  //     })
  //     .fail((xhr, textStatus, errorThrown) => {
  //       if (callback) callback(new ServResponse(xhr.status, errorThrown, null));
  //     });
  // }

  /**
   *
   * @param {DataManager.data} data
   * @param {function(ServResponse)} callback
   */
  static async loadData(data, callback, append, qParams) {
    // console.log("loadData query params: " + queryParams);
    return new Promise((resolve) => {
      // console.log("loadData: " + data.name);
      if (data.is_loading) {
        setTimeout(() => {
          DataManager.loadData(data, callback, append, qParams);
        }, 1000);
        // console.log("loadData : " + data.name + " loading  in progress");
        resolve();
        return;
      }
      data.is_loading = true;
      if (data.path) {
        HTTPSender.SendGETreq(data.path, qParams ?? data.queryParams)
          .done(async (resp) => {
            // console.log("data loaded with response");
            // console.log(resp);
            if (resp.success) {
              var res = JSON.parse(JSON.stringify(resp.payload), reviver); //.filter((d) => !d.Deleted);

              if (append && data.data instanceof Array) {
                data.data.push(res);
              } else {
                data.data = res;
                data.events = 0;
              }

              if (data.data && data.data.length > 0) {
                if (data.fixData) {
                  await data.fixData();
                }
                if (data.toStringFn) {
                  data.data.forEach((d) => {
                    d.toString = data.toStringFn;
                  });
                } else if (data.data[0].name) {
                  data.data.forEach((d) => {
                    d.toString = function () {
                      return d.name;
                    };
                  });
                }
              }
              if (callback) callback(new ServResponse(200, null, data.data));
              data.is_loading = false;
            } else {
              data.is_loading = false;
              if (callback) callback(new ServResponse(resp.err ? resp.err.code : 500, resp.err ? resp.err.message : "Грешка!", null));
            }
            resolve();
          })
          .fail((xhr, textStatus, errorThrown) => {
            if (callback) callback(new ServResponse(xhr.status, errorThrown, null));
            data.is_loading = false;
            // console.log("end loading with error " + data.name);
            resolve();
          });
      }
    });
  }

  // static edit(data, item, callback) {
  //   HTTPSender.SendPOSTreq(JSON.stringify(item), data.path, { update: true })
  //     .done((resp) => {
  //       callback(resp);
  //     })
  //     .fail((xhr, textStatus, errorThrown) => {
  //       if (callback) callback(new ServResponse(xhr.status, errorThrown, null));
  //     });
  // }
  // static delete(data, item, callback) {
  //   HTTPSender.SendPOSTreq(JSON.stringify(item), data.path, { delete: true })
  //     .done((resp) => {
  //       callback(resp);
  //     })
  //     .fail((xhr, textStatus, errorThrown) => {
  //       if (callback) callback(new ServResponse(xhr.status, errorThrown, null));
  //     });
  // }
  // static add(data, item, callback) {
  //   HTTPSender.SendPOSTreq(JSON.stringify(item), data.path, { add: true })
  //     .done((resp) => {
  //       callback(resp);
  //     })
  //     .fail((xhr, textStatus, errorThrown) => {
  //       if (callback) callback(new ServResponse(xhr.status, errorThrown, null));
  //     });
  // }
}

export default DataManager;
